<template>
  <div class="retired-container m-4 p-4">
    <div class="retired-content">
      <h1 class="title">MapViewer Retired</h1>
      <p class="message">The MapViewer map comparison tool has been retired.</p>
      <p class="message">
        For positions on the genome sequence, use
        <a :href="jbrowseUrl" target="_blank" rel="noopener">JBrowse</a>.
        Genetic and physical map positions of a marker or locus are listed
        under <b>Map Links</b> and <b>Map Locations</b> on its detail page.
      </p>
      <p v-if="value" class="message">
        You followed a link for <b>{{ value }}</b
        >.
        Search TAIR for {{ value }} in
        <router-link :to="searchLocation('genes')">genes</router-link> or
        <router-link :to="searchLocation('markers')">markers</router-link>.
      </p>
      <a :href="jbrowseUrl" target="_blank" rel="noopener" class="home-link"
        >Open JBrowse</a
      >
    </div>
  </div>
</template>

<script>
import { getDefaultJBrowse2Url } from "@/services/JBrowseService";

// TAIR3-396: tombstone page for the retired MapViewer (legacy /servlets/mapper).
export default {
  name: "MapViewerRetired",
  computed: {
    value() {
      const v = this.$route.query.value;
      return (Array.isArray(v) ? v[0] : v) || "";
    },
    jbrowseUrl() {
      return getDefaultJBrowse2Url();
    },
  },
  methods: {
    // Old MapViewer links carry either a locus ID or a marker name.
    searchLocation(category) {
      return {
        path: "/results",
        query: {
          mainType: "general",
          searchText: this.value,
          category,
        },
      };
    },
  },
};
</script>

<style scoped>
.retired-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #f9f9f9;
}

.retired-content {
  text-align: center;
  max-width: 600px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.title {
  color: #333;
  margin-bottom: 20px;
}

.message {
  color: #333;
  line-height: 1.6;
  margin-bottom: 20px;
}

.home-link {
  display: inline-block;
  background-color: #1976d2;
  color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.home-link:hover {
  background-color: #135ba1;
}
</style>
